import confettie from 'canvas-confetti';

export default confettie;